var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeOn = function SvgEyeOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.961,
    height: 22,
    fill: "none"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "EyeOn_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0,
    d: "M0 0h20.961v22H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#EyeOn_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#796B64",
    d: "M1.8 11.31a.86.86 0 0 1 0-.63q1.08-2.775 3.45-4.44c1.58-1.11 3.32-1.66 5.23-1.66 1.9 0 3.64.55 5.22 1.66s2.73 2.59 3.46 4.44q.105.315 0 .63c-.73 1.85-1.88 3.33-3.46 4.44s-3.32 1.66-5.22 1.66c-1.91 0-3.65-.55-5.23-1.66q-2.37-1.665-3.45-4.44"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#796B64",
    strokeLinejoin: "round",
    d: "M1.8 10.68q1.08-2.775 3.45-4.44c1.58-1.11 3.32-1.66 5.23-1.66 1.9 0 3.64.55 5.22 1.66s2.73 2.59 3.46 4.44q.105.315 0 .63c-.73 1.85-1.88 3.33-3.46 4.44s-3.32 1.66-5.22 1.66c-1.91 0-3.65-.55-5.23-1.66q-2.37-1.665-3.45-4.44a.86.86 0 0 1 0-.63Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.481,
    cy: 11,
    fill: "#FFF",
    rx: 2.62,
    ry: 2.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.481,
    cy: 11,
    stroke: "#FFF",
    strokeLinejoin: "round",
    rx: 2.62,
    ry: 2.75
  }))));
};
export default SvgEyeOn;